/**
 * The version footer.
 *
 * It reads the version from `GET /api/health` rather than embedding one at build time. That
 * is deliberate: the question this answers is "what is the server I am talking to?", and a
 * number baked into the bundle answers "what was I built from?" — which drifts the moment a
 * phone holds a cached PWA across a deploy, exactly when you most want the truth.
 *
 * It is also why there is no version in `frontend/package.json` any more. One authored copy,
 * in `backend/efss/__init__.py`.
 */

import { useEffect, useState } from "react";

import { api } from "../api";

/**
 * The private Gitea instance, for now. Phase 1 is one user on one host (§1), so a constant
 * is honest; a public release would need this configurable, and §14.1 records that.
 */
const REPO_URL = "https://gitea.nironwolf.com/nironwolf/efss";

export function Footer() {
  const [version, setVersion] = useState<string | null>(null);
  const [schema, setSchema] = useState<number | null>(null);

  useEffect(() => {
    let live = true;
    api
      .health()
      .then((health) => {
        if (!live) return;
        setVersion(health.version);
        setSchema(health.schema_version);
      })
      .catch(() => {
        // A footer is not worth an error state. If health cannot be reached the rest of the
        // app is already telling the user so, far more loudly than this line could.
      });
    return () => {
      live = false;
    };
  }, []);

  if (!version) return null;

  return (
    <footer className="footer">
      <a
        href={`${REPO_URL}/src/tag/v${version}`}
        target="_blank"
        rel="noreferrer"
        title={schema === null ? undefined : `Schema version ${schema}`}
      >
        eFss v{version}
      </a>
    </footer>
  );
}
